import { NgModule } from '@angular/core';
import { SafeUrlPipe, SafeHtmlPipe, SafeStylePipe, FormatNumberPipe } from './safe.pipe';
//I18n
import { TranslateModule } from '@ngx-translate/core';

/**
 * Tableaux de déclarations
 */
export const pipes = [
  SafeUrlPipe,
  SafeHtmlPipe,
  SafeStylePipe,
  FormatNumberPipe
];

/**
 * Ensemble des pipes
 *
 * @export
 * @class PipesModule
 */
@NgModule({
  declarations: pipes,
  imports: [
    TranslateModule
  ],
  exports: [
    SafeUrlPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    FormatNumberPipe,
    TranslateModule,
  ],
  providers: [
  ]
})
export class PipesModule { }
